import React, { Fragment, useCallback, useState } from "react";
import Request from "../../../core/requests";
import { ValidationSchemaChangePassword } from "../../../conf/login";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Loading } from "../../../components/common";
import CardFormComponent from "components/common/card/CardForm.component";
import ChangePasswordForm from "forms/profile/ChangePassword.form";
import { openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "react-redux";
import WrapperSliderCard from "components/common/card/WrapperSliderCard.component";

const ChangePasswordContainer = () => {
  const { t } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setSubmitting] = useState(null);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [loading, setLoading] = useState(false)

  const { handleSubmit, control, formState } = useForm({
    resolver: yupResolver(ValidationSchemaChangePassword),
    defaultValues: {
      password: "",
      matchingPassword: "",
    },
  });


  const onError = useCallback(
    (error, data) => {
      setLoading(false)
      if (isFirstRefresh) {
        if (error?.response?.status === 403) {
          onFailure(error);
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {

              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onFailure(error);
      }
    },
    // eslint-disable-next-line
    [isFirstRefresh]
  );

  const onSuccess = useCallback((resp) => {
    setLoading(false)
    setIsFirstRefresh(true)
    dispatch(
      openSnackbar({
        open: true,
        message: resp.message,
        variant: "alert",
        alert: {
          color: resp.status,
        },
        close: false,
      })
    );
    if (resp.status === "success") {
      setSubmitting(true);
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 1500);
    }
    // eslint-disable-next-line
  }, []);

  const onFailure = useCallback((error) => {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message ? error.response.data.message : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback((data) => {
    setLoading(true)
    Request.users
      .changePassword({ t: t }, data)
      .then((resp) => onSuccess(resp))
      .catch((error) => onError(error, data));
    // eslint-disable-next-line
  }, []);




  return (
    <Fragment>
      {loading && <Loading />}

      <WrapperSliderCard>
        <CardFormComponent
          title={t('change Password')}
          subTitle={t('Enter the new password')}
          subButton={{ label: t('Do you already have an account'), href: "/login" }}
        >
          <ChangePasswordForm
            errors={formState.errors}
            control={control}
            isSubmitting={isSubmitting}
            handleSubmit={handleSubmit(onSubmit)}
          />
        </CardFormComponent>
      </WrapperSliderCard>
    </Fragment>
  );
};

export default ChangePasswordContainer;
